<div mb-expandable-text height="216px">
  <div class="filter__panel__content__item">
    @if (allTypeOption) {
      <ul>
        <li>
          <mb-checkbox (valueChange)="
              valueChangeEmitter(
                $event,
                type === 'RECOMMENDED' ? allTypeOption.type : type,
                allTypeOption
              )
            " name="{{ allTypeOption?.code }}" [value]="allTypeSelected">
            <span i18n="@@filters__description__all">
              {allTypeOption?.description, select, all_STAR {Todas las estrellas} all_MEAL {Todos
              los Planes de comida} all_PAYMENT_METHOD {Todos los métodos de pago}
              all_ACCOMMODATION_TYPE {Todos los alojamientos} all_RATING {Todas las puntuaciones}
              all_AMENITY {Todos los servicios} all_NEARBY {Todos los lugares de interés}
              all_DISCOUNTS {Todos los descuentos}
              all_OFFERS {Todas las ofertas} other
              {{{allTypeOption?.description}}}}
            </span>
            @if (allTypeOption?.count && allTypeOption?.code !== 'all_OFFERS') {
              (@if (allTypeOption?.showPlus) {+}{{ allTypeOption.count }})
            }
          </mb-checkbox>
        </li>

        @if (type !== 'RECOMMENDED') {
          <li>
            <ul>
              @for (item of options; track item; let i = $index) {
                <li>
                  <mb-checkbox (mouseover)="setPopoverInfo(item)" (valueChange)="
                      valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)
                    " name="{{ item?.code }}" [value]="item?.isApplied" [disabled]="
                      !allTypeOption &&
                      type !== 'RECOMMENDED' &&
                      type !== 'DISCOUNTS' &&
                      allTypeSelected
                    ">
                    <span i18n="@@filters__description__all_payment">
                      {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
                      {{{item?.description}}}}
                    </span>
                    @if (item?.count && item?.code !== 'all_OFFERS') {
                      (@if (item?.showPlus) {+}{{ item.count }})
                    }
                  </mb-checkbox>
                </li>
              }
            </ul>
          </li>
        } @else {
          @for (item of options; track item; let i = $index) {
            <li>
              <mb-checkbox (mouseover)="setPopoverInfo(item)" (valueChange)="
                  valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)
                " name="{{ item?.code }}" [value]="item?.isApplied" [disabled]="
                  !allTypeOption && type !== 'RECOMMENDED' && type !== 'DISCOUNTS' && allTypeSelected
                ">
                <span i18n="@@filters__description__all_payment">
                  {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
                  {{{item?.description}}}}
                </span>
                @if (item?.count && item?.code !== 'all_OFFERS') {
                  (@if (item?.showPlus) {+}{{ item.count }})
                }
              </mb-checkbox>
            </li>
          }
        }
      </ul>
    } @else {
      <ul>
        @for (item of options; track item; let i = $index; let first = $first) {
          <li>
            <mb-checkbox (mouseover)="setPopoverInfo(item)"
              (valueChange)="valueChangeEmitter($event, type === 'RECOMMENDED' ? item.type : type, item)"
              name="{{ item?.code }}" [value]="item?.isApplied"
              [disabled]="first && type !== 'RECOMMENDED' && type !== 'DISCOUNTS' && allTypeSelected">
              <span i18n="@@filters__description__all_payment">
                {item?.description, select, all_PAYMENT_METHOD {Todos los métodos de pago} other
                {{{item?.description}}}}
              </span>
              @if (item?.count && item?.code !== 'all_OFFERS') {
                (@if (item?.showPlus) {+}{{ item.count }})
              }
            </mb-checkbox>
          </li>
        }
      </ul>
    }
  </div>
  <span mb-expand i18n="@@show-more">Ver más</span>
  <span mb-collapse i18n="@@show-less">Ver menos</span>
</div>